// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-input-file[data-v-86e85ec0]{display:none;position:absolute;height:.1px;width:.1px;overflow:hidden;opacity:0;z-index:-1}", ""]);
// Exports
module.exports = exports;
